import React, { useState } from 'react';
import { Modal, Form, Input, InputNumber, Select, message } from 'antd';
import { Category } from '@/types/models';
import apiService from '@/services/api.service';
import { API_ENDPOINTS } from '@/constants/api.constants';
import { logger } from '@/utils/logger';

interface CreateCategoryModalProps {
    visible: boolean;
    category: Category | null;
    onCancel: () => void;
    onSuccess: () => void;
}

export const CreateCategoryModal: React.FC<CreateCategoryModalProps> = ({
    visible,
    category,
    onCancel,
    onSuccess,
}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const values = await form.validateFields();

            if (category) {
                await apiService.put(
                    `${API_ENDPOINTS.CATEGORIES.BASE}/${category.id}`,
                    values
                );
            } else {
                await apiService.post(API_ENDPOINTS.CATEGORIES.BASE, values);
            }

            form.resetFields();
            onSuccess();
        } catch (error) {
            logger.error('Error creating/updating category:', error);
            message.error('Ошибка при создании/обновлении категории');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={category ? 'Редактировать категорию' : 'Создать категорию'}
            open={visible}
            onCancel={onCancel}
            onOk={handleSubmit}
            confirmLoading={loading}
            width={600}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={category || {}}
            >
                <Form.Item
                    name="name"
                    label="Название"
                    rules={[{ required: true, message: 'Введите название категории' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="ageFrom"
                    label="Возраст от"
                    rules={[{ required: true, message: 'Укажите минимальный возраст' }]}
                >
                    <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item
                    name="ageTo"
                    label="Возраст до"
                    rules={[{ required: true, message: 'Укажите максимальный возраст' }]}
                >
                    <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item
                    name="weightFrom"
                    label="Вес от (кг)"
                    rules={[{ required: true, message: 'Укажите минимальный вес' }]}
                >
                    <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item
                    name="weightTo"
                    label="Вес до (кг)"
                    rules={[{ required: true, message: 'Укажите максимальный вес' }]}
                >
                    <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item
                    name="gender"
                    label="Пол"
                    rules={[{ required: true, message: 'Выберите пол' }]}
                >
                    <Select>
                        <Select.Option value="male">Мужской</Select.Option>
                        <Select.Option value="female">Женский</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="beltLevels"
                    label="Уровни поясов"
                    rules={[{ required: true, message: 'Выберите уровни поясов' }]}
                >
                    <Select mode="multiple">
                        <Select.Option value="white">Белый</Select.Option>
                        <Select.Option value="yellow">Желтый</Select.Option>
                        <Select.Option value="orange">Оранжевый</Select.Option>
                        <Select.Option value="green">Зеленый</Select.Option>
                        <Select.Option value="blue">Синий</Select.Option>
                        <Select.Option value="brown">Коричневый</Select.Option>
                        <Select.Option value="black">Черный</Select.Option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};